const homepage = {
    title: 'Accueil',
    description:
        'Connecter les marques à leur public en développant des experiences web intuitives.',
}

export default homepage
